import React, { Component } from "react";
import Slider from "react-slick";
import FadeIn from "react-lazyload-fadein";
import Cinemagraph from '../global/Cinemagraph';
import { Link } from 'react-router-dom';
import { createPortal } from 'react-dom';

export default class ProjectGallery extends Component {
	
	constructor(props) {
    	super(props);
    	this.state = {
			index 	: 0,
			open 	: false,
			gOpen 	: false
		}
		this.handleToggle 			= this.handleToggle.bind(this);
		this.handleGalleryToggle 	= this.handleGalleryToggle.bind(this);
		this.handleGoTo 			= this.handleGoTo.bind(this);
    }
    	
	componentDidMount() {
		setTimeout(() => {
			if (window.document.getElementsByClassName('slick-prev').length > 0) {
				window.document.getElementsByClassName('slick-prev')[0].addEventListener('mouseover', function(){
					document.documentElement.classList.add('state-prev-hover');
				});
				window.document.getElementsByClassName('slick-prev')[0].addEventListener('mouseout', function(){
					document.documentElement.classList.remove('state-prev-hover');
				});
				window.document.getElementsByClassName('slick-next')[0].addEventListener('mouseover', function(){
					document.documentElement.classList.add('state-next-hover');
				});
				window.document.getElementsByClassName('slick-next')[0].addEventListener('mouseout', function(){
					document.documentElement.classList.remove('state-next-hover');
				});
			}
		}, 500);
	}
	
	handleToggle(_evt) {  
		_evt.preventDefault();  
	    if (this.state.open === true) {
	    	this.setState({ open : false });
	    	setTimeout(() => {
		    	this.setState({ gOpen : false, index : 0 });
		    }, 1000);
	    } else {
		    this.setState({ open : true });
	    }
    }
    
    handleGalleryToggle(_evt) {  
		_evt.preventDefault();  
	    if (this.state.gOpen === true) {
	    	this.setState({ gOpen : false });
	    } else {
		    this.setState({ gOpen : true });
	    }
    }
    
    handleGoTo(_evt) {
	    _evt.preventDefault();  
	    this.slider.slickGoTo(_evt.currentTarget.getAttribute('data-key'), false);
	    setTimeout(() => {
			this.setState({ open : true, gOpen : true });
		}, 10);
    }

  			
	render() {
		
		let gallery = this.props.gallery;
		let heading = this.props.heading;
		let prev 	= this.props.prev;
		
		if (gallery) {
	    	const settings = {
				dots: 			false,
				arrows: 		true,
				infinite: 		true,
				speed: 			0,
				slidesToScroll: 1,
				centerMode: 	false,
				variableWidth: 	false,
				beforeChange: 	(current, next) => this.setState({ index:next })
			};
			
			let galleryClass = 'c-project__gallery';
			if (this.state.open) {
				galleryClass = galleryClass + ' state-open';
			}
			if (this.state.gOpen) {
				galleryClass = galleryClass + ' state-gallery-open';
			}
			
			return (				
				
				<>
					
					{createPortal(
						<div className={galleryClass}>
							<div className="scope-slick">
								<div className="c-project__header">
																		
									<a href="#" className="c-project__header__back" dangerouslySetInnerHTML={{__html:'<svg width="28" height="6" viewBox="0 0 28 6"><path d="M0 3L5 5.88675V0.113249L0 3ZM28 2.5L4.5 2.5V3.5L28 3.5V2.5Z" /></svg>Back to project'}} onClick={this.handleToggle}></a>
									
									<a href="#" className="c-project__header__back-gallery" dangerouslySetInnerHTML={{__html:'Back to Gallery'}} onClick={this.handleGalleryToggle}></a>
									
									<h2 className="c-project__header__heading" dangerouslySetInnerHTML={{__html: heading}}></h2>		
															
								</div>
								<Slider ref={slider => (this.slider = slider)} {...settings}>
									{gallery.map((slide,i) =>
										{
											return (
												<>
													<div className="inner" key={i}>	
														<div className="c-project__gallery__slide">
															<FadeIn>
																{onload => (
																	<img
																		alt={''} 
																		src={slide.src} 
																		srcSet={slide.srcset} 
																		onLoad={onload}
																	/>
																)}
															</FadeIn>
															
														</div>
														
													</div>
													<p href="#" className="counter" dangerouslySetInnerHTML={{__html: (((i + 1) < 10) ? ("0" + (i + 1)) : (i + 1)) + ' of ' +  (gallery.length)}}></p>
												</>
											)
										}
									)}
								</Slider>
								
							</div>
							<div className="c-project__gallery__thumbs">
								<div className="c-project__gallery__thumbs__inner">
									<div className="c-project__gallery__thumbs__wrap">
										{gallery.map((slide,i) =>
											{
												let tClass = 'c-project__gallery__thumb c-project__gallery__thumb--landscape';
												if (slide.width < slide.height) {
													tClass = 'c-project__gallery__thumb c-project__gallery__thumb--portrait';
												}
												
												return (
													<div className={tClass} key={i}>
													
														<a href="#" className="c-project__gallery__thumb__image" data-key={i} onClick={this.handleGoTo}>													
															<FadeIn>
																{onload => (
																	<img
																		alt={''} 
																		src={slide.src} 
																		offset={10000}
																		srcSet={slide.srcset} 
																		onLoad={onload}
																	/>
																)}
															</FadeIn>
														</a>
														<p className="c-project__gallery__thumb__count" dangerouslySetInnerHTML={{__html: (((i + 1) < 10) ? ("0" + (i + 1)) : (i + 1))}}></p>
													</div>
												)
											}
										)}
										
									</div>
								</div>
							</div>
						</div>,
						document.body
					)}
					
					<a href="#" className="c-project__gallery-toggle c-page__block--load-effect" onClick={this.handleToggle}>View Image Gallery</a>

				</>
				
									
			);
			
		} else {
			return null;
		}
	}
}